import React, { useState } from "react";
import { BsCheckCircleFill } from "react-icons/bs";
import { Link, useNavigate, useParams } from "react-router-dom";
import { logoLight } from "../../assets/images";
import { signupStep1, validateEmailOTP } from '../../api/Api';
import toast, { Toaster } from "react-hot-toast";
import { useContextSelector } from "use-context-selector";
import { StateContext } from "../../contexts/StateContext";
import { ACCESS_TOKEN, ADMIN_TOKEN } from "../../config/Config";

const SignUp = (props) => {
  const navigate = useNavigate();
  let { message } = useParams();
  console.log("message from useParams" + message);
  
  const isLoggedIn = useContextSelector(
    StateContext,
    (state) => state.isLoggedIn
  );
  const setIsLoggedIn = useContextSelector(
    StateContext,
    (state) => state.setIsLoggedIn
  );
  const setRole = useContextSelector(
    StateContext,
    (state) => state.setRole
  );

  // ============= Initial State Start here =============
  const [clientName, setClientName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [aadhar, setAadhar] = useState("");
  const [pan, setPan] = useState("");
  const [orgName, setOrgName] = useState("");
  const [password, setPassword] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [zip, setZip] = useState("");
  const [checked, setChecked] = useState(false);
  const [otpPageEnabled, setOtpPageEnabled] = useState(false);
  // ============= Initial State End here ===============

  // ============= Error Msg Start here =================
  const [errClientName, setErrClientName] = useState("");
  const [errEmail, setErrEmail] = useState("");
  const [errPhone, setErrPhone] = useState("");
  const [errAadhar, setErrAadhar] = useState("");
  const [errPan, setErrPan] = useState("");
  const [messageFromProps, setMessageFromProps] = useState("");
  const [errPassword, setErrPassword] = useState("");
  const [errAddress, setErrAddress] = useState("");
  const [errCity, setErrCity] = useState("");
  const [errCountry, setErrCountry] = useState("");
  const [errZip, setErrZip] = useState("");
  // ============= Error Msg End here ===================

  const [successMsg, setSuccessMsg] = useState("");
  const [otp, setOtp] = useState("");
  const [errOTP, setErrOTP] = useState("");

  // ============= Validation Functions =============
  const validatePhone = (phone) => {
    const phoneRegex = /^[6-9]\d{9}$/; // Indian phone numbers starting with 6-9
    return phoneRegex.test(phone);
  };

  const validateAadhar = (aadhar) => {
    const aadharRegex = /^\d{12}$/;
    return aadharRegex.test(aadhar);
  };

  const validatePAN = (pan) => {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    return panRegex.test(pan);
  };

  const validateName = (name) => {
    const nameRegex = /^[a-zA-Z\s]{2,50}$/;
    return nameRegex.test(name.trim());
  };

  const validateForm = () => {
    let isValid = true;

    // Validate Name
    if (!clientName.trim()) {
      setErrClientName("Enter your name");
      isValid = false;
    } else if (!validateName(clientName)) {
      setErrClientName("Name should contain only letters and spaces (2-50 characters)");
      isValid = false;
    } else {
      setErrClientName("");
    }

    // Validate Phone
    if (!phone) {
      setErrPhone("Enter your phone number");
      isValid = false;
    } else if (phone.length !== 10) {
      setErrPhone("Phone number must be exactly 10 digits");
      isValid = false;
    } else if (!validatePhone(phone)) {
      setErrPhone("Enter a valid 10-digit Indian phone number (should start with 6-9)");
      isValid = false;
    } else {
      setErrPhone("");
    }

    // Validate Aadhar
    if (!aadhar) {
      setErrAadhar("Enter your Aadhar number");
      isValid = false;
    } else if (aadhar.length !== 12) {
      setErrAadhar("Aadhar number must be exactly 12 digits");
      isValid = false;
    } else if (!validateAadhar(aadhar)) {
      setErrAadhar("Enter a valid 12-digit Aadhar number");
      isValid = false;
    } else {
      setErrAadhar("");
    }

    // Validate PAN
    if (!pan) {
      setErrPan("Enter your PAN number");
      isValid = false;
    } else if (pan.length !== 10) {
      setErrPan("PAN number must be exactly 10 characters");
      isValid = false;
    } else if (!validatePAN(pan)) {
      setErrPan("Enter a valid PAN number (format: ABCDE1234F)");
      isValid = false;
    } else {
      setErrPan("");
    }

    // Validate Terms & Conditions
    if (!checked) {
      toast.error("Please accept Terms of Service and Privacy Policy");
      isValid = false;
    }

    return isValid;
  };

  // ============= Event Handlers =============
  const handleOtpChange = (e) => {
    setOtp(e.target.value);
    setErrOTP("");
  };

  const handleVerifyOTP = () => {
    if (!otp) {
      setErrOTP("Enter the OTP");
    } else {
      const otpValidationRequest = {
        email: email,
        otp: otp,
        mobileAsPassword: phone,
      };

      validateEmailOTP(otpValidationRequest)
        .then((res) => {
          localStorage.setItem(
            ACCESS_TOKEN,
            res.accessToken ? res.accessToken : null
          );
          setIsLoggedIn(true);
          let token = res.accessToken;
          const base64Url = token.split(".")[1];
          const base64 = base64Url.replace("-", "+").replace("_", "/");
          token = JSON.parse(window.atob(base64));

          if (token.exp <= Math.floor(Date.now() / 1000)) {
            localStorage.removeItem(ACCESS_TOKEN);
            localStorage.removeItem(ADMIN_TOKEN);
            isLoggedIn(false);
          }

          if (token.rol.length >= 1) {
            setRole(token.rol[0]);
          }
          
          toast.success("Sign up successful!");
          navigate("/");
        })
        .catch((error) => {
          toast.error("Invalid OTP. Please try again!");
          console.error(error);
        });
    }
  };

  const handleName = (e) => {
    setClientName(e.target.value);
    setErrClientName("");
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
    setErrEmail("");
  };

  const handlePhone = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) {
      setPhone(value);
      setErrPhone("");
    }
  };

  const handleAadhar = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 12) {
      setAadhar(value);
      setErrAadhar("");
    }
  };

  const handlePan = (e) => {
    const value = e.target.value.toUpperCase();
    const regex = /^[A-Z0-9]*$/;
    if (regex.test(value) && value.length <= 10) {
      setPan(value);
      setErrPan("");
    }
  };

  const handlePassword = (e) => {
    setPassword(e.target.value);
    setErrPassword("");
  };

  const handleAddress = (e) => {
    setAddress(e.target.value);
    setErrAddress("");
  };

  const handleCity = (e) => {
    setCity(e.target.value);
    setErrCity("");
  };

  const handleCountry = (e) => {
    setCountry(e.target.value);
    setErrCountry("");
  };

  const handleZip = (e) => {
    setZip(e.target.value);
    setErrZip("");
  };

  const clearAlert = () => {
    toast.success("");
    toast.error("");
  };

  const handleSignUp = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    if (!validateForm()) {
      return; // Stop submission if validation fails
    }

    // If all validations pass, proceed with API call
    const signUpRequest = {
      name: clientName.trim(),
      email: phone + "@yaazhtech.com",
      mobile: phone,
      aadhar: aadhar,
      pan: pan,
      orgName: "gvg",
      appliedFor: "",
      password: phone,
    };

    signupStep1(signUpRequest)
      .then((res) => {
        localStorage.setItem(
          ACCESS_TOKEN,
          res.accessToken ? res.accessToken : null
        );
        setIsLoggedIn(true);
        
        let token = res.accessToken;
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace("-", "+").replace("_", "/");
        token = JSON.parse(window.atob(base64));

        if (token.exp <= Math.floor(Date.now() / 1000)) {
          localStorage.removeItem(ACCESS_TOKEN);
          localStorage.removeItem(ADMIN_TOKEN);
          isLoggedIn(false);
        }

        if (token.rol.length >= 1) {
          setRole(token.rol[0]);
        }

        toast.success(res.message || "Sign up successful!");
        navigate("/");
      })
      .catch((error) => {
        if (error.message) {
          toast.error(error.message);
        } else {
          toast.error("Sorry! Something went wrong. Please try again!");
        }
        console.log(error);
      });
  };

  return (
    otpPageEnabled ? (
      <div className="max-w-md mx-auto mt-20 p-6 bg-white rounded-md shadow-md">
        <h2 className="text-2xl font-bold mb-4">Email OTP Verification</h2>
        <p>
          Hello dear {clientName}, We sent an OTP to {email}. Please enter the
          OTP to complete the signup process.
        </p>
        <input
          type="text"
          value={otp}
          onChange={handleOtpChange}
          placeholder="Enter OTP"
          className="w-full mt-4 p-2 border border-gray-300 rounded-md"
        />
        {errOTP && <p className="text-red-500 mt-2">{errOTP}</p>}
        <button
          onClick={handleVerifyOTP}
          className="w-full mt-4 p-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:border-blue-300"
        >
          Verify OTP
        </button>
        <p className="mt-4 text-sm">
          Didn't receive the OTP?{" "}
          <Link to="/resendotp" className="text-blue-500">
            Resend OTP
          </Link>
        </p>
        <Toaster
          position="bottom-right"
          reverseOrder={false}
          toastOptions={{
            error: {
              duration: 6000,
              style: {
                background: "#FF4136",
                color: "#fff",
              },
            },
            success: {
              duration: 6000,
              style: {
                background: "#008000",
                color: "#fff",
              },
            },
          }}
        />
      </div>
    ) : (
      <div className="w-full h-screen flex items-center justify-start">
        <div className="w-1/2 hidden lgl:inline-flex h-full text-white">
          <div className="w-[450px] h-full bg-primeColor px-10 flex flex-col gap-2 justify-center">
            <Link to="/">
              <img src={logoLight} alt="logoImg" className="w-28" />
            </Link>
            <div className="flex flex-col gap-1 -mt-1">
              <h1 className="font-titleFont text-xl font-medium">
                Ready to join
              </h1>
              <p className="text-base">Create your account to access more</p>
            </div>
            <div className="w-[300px] flex items-start gap-3">
              <span className="text-green-500 mt-1">
                <BsCheckCircleFill />
              </span>
              <p className="text-base text-gray-300">
                <span className="text-white font-semibold font-titleFont">
                  Scheme 1
                </span>
                <br />
                Monthly pay 1250 up to 12 months Benefits : 3 gram KDM 916
                hallmark Gold coin (or) 2 Gram KDM 916 hallmark gold coin and 50
                gram silver jewels or Silver coin
              </p>
            </div>
            <div className="w-[300px] flex items-start gap-3">
              <span className="text-green-500 mt-1">
                <BsCheckCircleFill />
              </span>
              <p className="text-base text-gray-300">
                <span className="text-white font-semibold font-titleFont">
                  Scheme 2
                </span>
                <br />
                Monthly pay 2500 up to 12 months Benefits : 6 gram KDM 916
                hallmark Gold coin (or) 4 Gram KDM 916 hallmark gold coin and 120
                gram silver jewels or Silver coin
              </p>
            </div>
            <div className="w-[300px] flex items-start gap-3">
              <span className="text-green-500 mt-1">
                <BsCheckCircleFill />
              </span>
              <p className="text-base text-gray-300">
                <span className="text-white font-semibold font-titleFont">
                  Scheme 3
                </span>
                <br />
                Monthly pay 5000 up to 12 months Benefits : 12 gram KDM 916
                hallmark Gold coin (or) 8 Gram KDM 916 hallmark gold coin and 250
                gram silver jewels or Silver coin
              </p>
            </div>
            <div className="flex items-center justify-between mt-10">
              <Link to="/">
                <p className="text-sm font-titleFont font-semibold text-gray-300 hover:text-white cursor-pointer duration-300">
                  © gvgorder
                </p>
              </Link>
              <Link to="/Terms">
                <p className="text-sm font-titleFont font-semibold text-gray-300 hover:text-white cursor-pointer duration-300">
                  Terms
                </p>
              </Link>
              <Link to="/PrivacyPolicy">
                <p className="text-sm font-titleFont font-semibold text-gray-300 hover:text-white cursor-pointer duration-300">
                  Privacy
                </p>
              </Link>
              <p className="text-sm font-titleFont font-semibold text-gray-300 hover:text-white cursor-pointer duration-300">
                Security
              </p>
            </div>
          </div>
        </div>
        <div className="w-full lgl:w-[500px] h-full flex flex-col justify-center">
          {successMsg ? (
            <div className="w-[500px]">
              <p className="w-full px-4 py-10 text-green-500 font-medium font-titleFont">
                {successMsg}
              </p>
              <Link to="/signin">
                <button
                  className="w-full h-10 bg-primeColor rounded-md text-gray-200 text-base font-titleFont font-semibold 
            tracking-wide hover:bg-black hover:text-white duration-300"
                >
                  Sign in
                </button>
              </Link>
            </div>
          ) : (
            <form className="w-full lgl:w-[500px] h-screen flex items-center justify-center">
              <div className="px-6 py-4 w-full h-[96%] flex flex-col justify-start overflow-y-scroll scrollbar-thin scrollbar-thumb-primeColor">
                {message !== ':message' ? (
                  <p className="w-full px-4 py-10 text-yellow-500 font-medium font-titleFont">
                    {message}
                  </p>
                ) : null}

                <h1 className="font-titleFont underline underline-offset-4 decoration-[1px] font-semibold text-2xl mdl:text-3xl mb-4">
                  Create your account
                </h1>
                <div className="flex flex-col gap-3">
                  {/* client name */}
                  <div className="flex flex-col gap-.5">
                    <p className="font-titleFont text-base font-semibold text-gray-600">
                      Full Name
                    </p>
                    <input
                      onChange={handleName}
                      value={clientName}
                      className="w-full h-8 placeholder:text-sm placeholder:tracking-wide px-4 text-base font-medium placeholder:font-normal rounded-md border-[1px] border-gray-400 outline-none"
                      type="text"
                      placeholder="eg. John Doe"
                    />
                    {errClientName && (
                      <p className="text-sm text-red-500 font-titleFont font-semibold px-4">
                        <span className="font-bold italic mr-1">!</span>
                        {errClientName}
                      </p>
                    )}
                  </div>

                  {/* Phone Number */}
                  <div className="flex flex-col gap-.5">
                    <p className="font-titleFont text-base font-semibold text-gray-600">
                      Mobile Number
                    </p>
                    <input
                      onChange={handlePhone}
                      value={phone}
                      className="w-full h-8 placeholder:text-sm placeholder:tracking-wide px-4 text-base font-medium placeholder:font-normal rounded-md border-[1px] border-gray-400 outline-none"
                      type="text"
                      placeholder="1234567890"
                      maxLength="10"
                    />
                    {errPhone && (
                      <p className="text-sm text-red-500 font-titleFont font-semibold px-4">
                        <span className="font-bold italic mr-1">!</span>
                        {errPhone}
                      </p>
                    )}
                  </div>

                  {/* Aadhar Number */}
                  <div className="flex flex-col gap-.5">
                    <p className="font-titleFont text-base font-semibold text-gray-600">
                      Aadhar Number
                    </p>
                    <input
                      onChange={handleAadhar}
                      value={aadhar}
                      className="w-full h-8 placeholder:text-sm placeholder:tracking-wide px-4 text-base font-medium placeholder:font-normal rounded-md border-[1px] border-gray-400 outline-none"
                      type="text"
                      placeholder="123456789012"
                      maxLength="12"
                    />
                    {errAadhar && (
                      <p className="text-sm text-red-500 font-titleFont font-semibold px-4">
                        <span className="font-bold italic mr-1">!</span>
                        {errAadhar}
                      </p>
                    )}
                  </div>

                  {/* PAN Number */}
                  <div className="flex flex-col gap-.5">
                    <p className="font-titleFont text-base font-semibold text-gray-600">
                      PAN Number
                    </p>
                    <input
                      onChange={handlePan}
                      value={pan}
                      className="w-full h-8 placeholder:text-sm placeholder:tracking-wide px-4 text-base font-medium placeholder:font-normal rounded-md border-[1px] border-gray-400 outline-none"
                      type="text"
                      placeholder="ABCDE1234F"
                      maxLength="10"
                    />
                    {errPan && (
                      <p className="text-sm text-red-500 font-titleFont font-semibold px-4">
                        <span className="font-bold italic mr-1">!</span>
                        {errPan}
                      </p>
                    )}
                  </div>

                  {/* Checkbox */}
                  <div className="flex items-start mdl:items-center gap-2">
                    <input
                      onChange={() => setChecked(!checked)}
                      className="w-4 h-4 mt-1 mdl:mt-0 cursor-pointer"
                      type="checkbox"
                    />
                    <p className="text-sm text-primeColor">
                      I agree to the GVG Group of companies{" "}
                      <Link to="/Terms">
                        <span className="text-blue-500">Terms of Service </span>{" "}
                      </Link>
                      and{" "}
                      <Link to="/PrivacyPolicy">
                        <span className="text-blue-500">Privacy Policy</span>.
                      </Link>
                    </p>
                  </div>
                  <button
                    onClick={handleSignUp}
                    className={`${
                      checked
                        ? "bg-blue-500 hover:bg-blue-600 hover:text-white cursor-pointer"
                        : "bg-gray-500 hover:bg-gray-500 hover:text-gray-200 cursor-not-allowed"
                    } w-full text-gray-200 text-base font-medium h-10 rounded-md hover:text-white duration-300`}
                    disabled={!checked}
                  >
                    Create Account
                  </button>

                  <p className="text-sm text-center font-titleFont font-medium">
                    Don't have an Account?{" "}
                    <Link to="/signin">
                      <span className="hover:text-blue-600 duration-300">
                        Sign in
                      </span>
                    </Link>
                  </p>
                  <Link to="/">
                    <button
                      className="bg-gray-500 hover:bg-gray-400 text-gray-200 hover:text-white cursor-pointer w-full text-base font-medium h-10 rounded-md duration-300"
                    >
                      Back
                    </button>
                  </Link>
                </div>
              </div>
            </form>
          )}
        </div>
        <Toaster
          position="bottom-right"
          reverseOrder={false}
          toastOptions={{
            error: {
              duration: 6000,
              style: {
                background: "#FF4136",
                color: "#fff",
              },
            },
            success: {
              duration: 6000,
              style: {
                background: "#008000",
                color: "#fff",
              },
            },
          }}
        />
      </div>
    )
  );
};

export default SignUp;